export default __webpack_public_path__ + "static/media/nft-gif.a1b091d6.gif";